import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { LicenceTableDto } from '../../../entity/licenceTableDto';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-licence-carousel',
  templateUrl: './licence-carousel.component.html',
  styleUrls: ['./licence-carousel.component.scss'],
})
export class LicenceCarouselComponent implements OnInit {
  @Input() activeLicenceId: number;
  @Input() licences$: Observable<LicenceTableDto[]>;
  licences: LicenceTableDto[];

  @ViewChild('carouselContent', { read: ElementRef })
  carouselContent: ElementRef;
  @ViewChild('carouselCards', { read: ElementRef }) carouselCards: ElementRef;

  constructor() {}

  public ngOnInit(): void {
    this.licences$.subscribe((res) => {
      this.licences = res;
    });
  }

  scrollLeft() {
    this.carouselContent.nativeElement.scrollTo({
      left:
        this.carouselContent.nativeElement.scrollLeft -
        this.carouselCards.nativeElement.offsetWidth * 2,
      behavior: 'smooth',
    });
  }

  scrollRight() {
    this.carouselContent.nativeElement.scrollTo({
      left:
        this.carouselContent.nativeElement.scrollLeft +
        this.carouselCards.nativeElement.offsetWidth * 2,
      behavior: 'smooth',
    });
  }
}
